export function storageGet(key) {
    try {
        return window.localStorage.getItem(key);
    }
    catch {
        return null;
    }
}
export function storageSet(key, value) {
    try {
        window.localStorage.setItem(key, value);
    }
    catch {
        /* localStorage puede estar bloqueado por politicas del navegador. */
    }
}
export function storageRemove(key) {
    try {
        window.localStorage.removeItem(key);
    }
    catch {
        /* localStorage puede estar bloqueado por politicas del navegador. */
    }
}
